import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleDimension3Selected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <circle id="pic_circle_dimension3-selected_svg__a" cx={28} cy={28} r={28} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="pic_circle_dimension3-selected_svg__b" fill="#fff">
          <use xlinkHref="#pic_circle_dimension3-selected_svg__a" />
        </mask>
        <use fill="#56A" opacity={0.88} xlinkHref="#pic_circle_dimension3-selected_svg__a" />
        <g mask="url(#pic_circle_dimension3-selected_svg__b)">
          <path
            d="M39.83 20.26c.25.08.34.34.34.6 0 .25-.17.5-.34.6l-10.97 5.89c-.42.26-1 .26-1.43 0l-10.89-5.98c-.25-.09-.33-.34-.33-.6 0-.26.17-.51.33-.6l10.98-5.98c.42-.25 1-.25 1.42 0l10.9 6.07z"
            fill="#FFF"
          />
          <path
            d="M26.73 28.78c.4.25.73.67.73 1.16l-.08 11.54c0 .25-.16.5-.33.58-.24.09-.48.09-.64 0l-9.68-5.23a1.25 1.25 0 01-.73-1.16V24.05c0-.25.16-.5.32-.58.24-.08.49-.17.65 0l9.76 5.31z"
            fill="#8F9DD6"
          />
          <path
            d="M39.4 23.44c.25-.09.5-.09.65 0 .24.08.33.33.33.58v11.64c0 .5-.25.91-.73 1.16l-9.68 5.24c-.25.09-.49.09-.65 0-.24-.08-.32-.33-.32-.58l-.08-11.56c0-.5.24-.91.72-1.16l9.77-5.32z"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicCircleDimension3Selected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleDimension3Selected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleDimension3Selected svgRef={ref} {...props} />
));
export default ForwardRef;
